import { render, staticRenderFns } from "./QRA.vue?vue&type=template&id=5744aa98"
import script from "./QRA.vue?vue&type=script&lang=js"
export * from "./QRA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports